/** @format */

import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import Tooltip from "../Common/Tooltip";
import { roles } from "../../Config/Roles";
import { AuthContext } from "../../Contexts/AuthContext";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import ActionModal from "../Common/ActionModal";
import ResultModal from "../Common/ResultModal";
import SpinnerLoading from "../Common/SpinnerLoading";
import Add from "./Add";
import { migrationServices } from "../../Services/migration.services";
// import Loading from "react-fullscreen-loading";

const Index = () => {
  const { t: translator } = useTranslation();
  const { updateLocName } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;

  const isActionAllowed = [master, admin, support].includes(parseInt(roleId));

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [updateData, setUpdateData] = useState(null);
  const [update, setUpdate] = useState(new Date());
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const [resultModal, setResultModal] = useState({
    show: false,
    title: "",
    text: "",
    btnClass: "",
  });

  const [actionModal, setActionModal] = useState({
    show: false,
    title: "",
    text: "",
    confirmBtn: "",
  });

  useEffect(() => updateLocName("migration"), []);
  useEffect(() => {
    setIsLoading(true);
    migrationServices
      .getAllActive({
        searchText,
        pageSize: pagination.pageSize,
        pageIndex: pagination.pageIndex,
      })
      .then((res) => {
        setData(res?.data?.data || []);
        setPagination((pagination) => ({
          ...pagination,
          totalCount: res.data.totalCount,
        }));
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [update]);

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const onClickDelete = (rowId) => {
    setActionModal({
      show: true,
      title: "Brisanje",
      text: "Jeste li sigurni u brisanje?",
      confirmBtn: "CardTypes-Delete-Btn",
      confirmAction: () => confirmDelete(rowId),
    });
  };
  const onClickExecute = (rowId) => {
    setActionModal({
      show: true,
      title: "Migracija",
      text: "Ovom akcijom će te migrirati odabrani OIB. Akciju nije moguće stornirati. Jeste li sigurni?",
      confirmBtn: "Potvrdi",
      confirmAction: () => confirmExecute(rowId),
    });
  };

  function actionFormatter(cell, row) {
    return (
      <div
        className="action"
        onClick={(e) => {
          e.stopPropagation();
          onClickDelete(row.oib);
        }}
      >
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }
  function dateTimeFormatter(cell, row) {
    return cell != null ? (
      new Intl.DateTimeFormat("hr", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }).format(new Date(cell))
    ) : (
      <span></span>
    );
  }
  function actionFormatterExecute(cell, row) {
    return row.migrateDate != null && row.executed == null ? (
      <div
        className="action"
        onClick={(e) => {
          e.stopPropagation();
          onClickExecute(row.oib);
        }}
      >
        <span
          className="icon icon-redirection"
          style={{ color: "blue" }}
        ></span>
      </div>
    ) : (
      <div></div>
    );
  }

  const columns = [
    {
      dataField: "id",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      hidden: !isActionAllowed,
      // hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
    },
    {
      dataField: "oib",
      text: translator("OIB"),
    },
    {
      dataField: "startDate",
      formatter: dateTimeFormatter,
      text: translator("Datum unosa"),
    },
    {
      dataField: "migrateDate",
      formatter: dateTimeFormatter,
      text: translator("Datum migracije"),
    },
    {
      dataField: "executed",
      formatter: dateTimeFormatter,
      text: translator("Datum izvršavanja"),
    },
    {
      dataField: "isExecuted",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatterExecute,

      // hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
    },
  ];
  const rowEvents = {
    onClick: (e, row, rowIndex) => {},
  };

  const confirmDelete = (id) => {
    migrationServices
      .remove(id)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        setResultModal({
          ...resultModal,
          title: translator("Uspješna akcija"),
          text: translator("Oib uspješno uklonjen iz liste za migraciju"),
          show: true,
          btnClass: "btn btn-primary",
        });
        setUpdate(new Date());
      })
      .catch((err) =>
        setResultModal({
          ...resultModal,
          title: translator("Greška"),
          text: data.message,
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  const confirmExecute = (id) => {
    setActionModal({ ...actionModal, show: false });
    setIsLoading(true);
    migrationServices
      .migrate(id)
      .then((data) => {
        setIsLoading(false);
        data.data.success
          ? setResultModal({
              ...resultModal,
              title: translator("Uspješna akcija"),
              text: translator("Oib uspješno migriran"),
              show: true,
              btnClass: "btn btn-primary",
            })
          : setResultModal({
              ...resultModal,
              title: translator("Greška"),
              text: data.data.message,
              show: true,
              btnClass: "btn btn-primary",
            });
        setUpdate(new Date());
      })
      .catch((err) =>
        setResultModal({
          ...resultModal,
          title: translator("Greška"),
          text: data.message,
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Migration-Add")}</span>
        </div>
        <div className="card-body ">
          <div className="row">
            <div className="col-md-4 col-sm-12 mt-2">
              {!updateData && (
                <Add
                  onSuccess={() => {
                    setUpdate(new Date());
                    setUpdateData(null);
                  }}
                  disabled={!isActionAllowed}
                  setResultModal={setResultModal}
                />
              )}
            </div>
            <div className="col-md-8 col-sm-12 mt-2">
              <div className="d-flex justify-content-between align-items-end">
                <div className="mb-2">
                  <label>{translator("PayOption-View-Name")}</label>
                  <Tooltip text={translator("PayOptionTooltip-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    value={searchText}
                    onChange={(event) => {
                      setSearchText(event.target.value);
                      setUpdate(new Date());
                    }}
                  />
                </div>
              </div>
              {isLoading ? (
                <div className="dashboard-card-spinner">
                  <SpinnerLoading />
                </div>
              ) : (
                <BootstrapTable
                  remote
                  keyField="oib"
                  data={data}
                  columns={columns}
                  rowClasses="boostrap-table-row"
                  search
                  rowEvents={rowEvents}
                  noDataIndication={translator("No-Data")}
                  pagination={paginationFactory({
                    page: pagination.pageIndex + 1,
                    sizePerPage: pagination.pageSize,
                    totalSize: pagination.totalCount,
                  })}
                  onTableChange={handleTableChange}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Loading
        loading={isLoading}
        background="rgba(60, 60, 60, 0.5)"
        loaderColor={process.env.REACT_APP_COLOR}
      /> */}
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={() => {
          setResultModal({ ...resultModal, show: false });
          setUpdateData(null);
        }}
      />

      <ActionModal
        show={actionModal.show}
        handleHide={() => {
          setActionModal({ ...actionModal, show: false });
        }}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
    </div>
  );
};

export default Index;
